<template>
  <div class="container">
    <div class="flex flex-row-left  margin-top-20 ">
      <div class="flex-item-center">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="产品SKU">
            <el-input style="width:200px" v-model="formInline.materialNo" placeholder="产品SKU" clearable />
          </el-form-item>
          <el-form-item label="产品相关">
            <el-input style="width:200px" v-model="formInline.materialName" placeholder="名称" clearable />
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onSubmit">查询</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div>
        <el-button type="danger" @click="openEidt" >导入SN号</el-button>
      </div>
    </div>
    <div class="margin-20-0">
      <div>
        <el-table
            :max-height="tableHeight"
            :data="tableData"
            :preserve-expanded-content="true"
            :stripe="true" :border="true"
            :highlight-current-row="true"
            size="default"
            @sort-change="handleSortChange"
            @selection-change="handleSelectionChange"
        >
          <el-table-column
              header-align="center"
              label="商品SKU"
              min-width="100"
              prop="MaterialNu"
          ></el-table-column>
          <el-table-column
              header-align="center"
              label="商品名称"
              min-width="100"
              prop="MaterialName"
          ></el-table-column>
          <el-table-column
              header-align="center"
              label="产品库存"
              min-width="80"
              prop="sumStock"
          ></el-table-column>
          <el-table-column
              header-align="center"
              label="长"
              min-width="80"
              prop="Length"
          ></el-table-column>
          <el-table-column
              header-align="center"
              label="宽"
              min-width="80"
              prop="Width"
          ></el-table-column>
          <el-table-column
              header-align="center"
              label="高"
              min-width="80"
              prop="Height"
          ></el-table-column>
          <el-table-column
              header-align="center"
              label="重量"
              min-width="80"
              prop="FWeight"
          ></el-table-column>
          <el-table-column
              header-align="center"
              label="操作"
              min-width="80"
              class="flex flex-row-between align-center"
          >
            <template #default="scope">
              <el-button link type="primary" size="small" @click="handleClick(scope.row)">库存详情</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <div class="flex flex-row-center flex-item-center margin-10-0 pagination">
        <el-pagination v-model:current-page="currentPage"  :page-size="pageSize" :total="pageTotal" :page-sizes="[10, 20, 30, 50]" @size-change="handleSizeChange"
                       @current-change="handleCurrentChange" background layout="total, sizes, prev, pager, next,"  />
      </div>
    </div>
    <stockInfo ref="stockInfo"  @closeEdit="close" ></stockInfo>
    <uploadFile ref="uploadFile"  @closeEdit="close" ></uploadFile>
  </div>
</template>
<script>
import {ElForm,ElFormItem,ElButton,ElInput,ElTable,
  ElTableColumn,ElPagination} from "element-plus";
import stockInfo from "@/components/stockInfo.vue";
import uploadFile from "@/components/uploadFile.vue";
import {getBaseMater} from "@/utils/api";
export default {
  name: "comModity",
  components: {
    ElForm,ElFormItem,ElButton,ElInput,ElTable,
    ElTableColumn,ElPagination,stockInfo,uploadFile
  },
  data(){
    return{
      tableHeight:0,
      formInline:{},
      tableData:[],
      inDate:0,
      outDate:0,
      repair:0,
      currentPage:1,
      pageSize:20,
      pageTotal:0,
      curData:{}
    }
  },
  computed() {

  },
  beforeMount(){
    this.tableHeight = window.innerHeight-200
    this.getAll()
  },
  methods:{
    getAll(){
      getBaseMater({...this.formInline,PageSize:this.pageSize,PageNumber:this.currentPage} ).then((res)=>{
        this.tableData = res.Data.data
        this.pageTotal = res.Data.count
      }).catch((err)=>{
        console.log(err)
      })
    },
    handleSizeChange(val){
      this.pageSize = val;
      this.getAll();
    },
    handleCurrentChange(val){
      this.currentPage = val;
      this.getAll();
    },
    onSubmit(){
      this.PageNumber = 1
      this.getAll();
    },
    close(){
      //this.getAll()
    },
    openEidt(){
      this.$refs.uploadFile.open()
    },
    check(data){
      this.curData = data
      this.$refs.stockInfo.open()
    },
    handleClick(row){
      this.$refs.stockInfo.open(row.MaterialNu)
    },
  }
}
</script>
<style scoped>
.container{
  width: 90%;
  margin:0 auto;
}
::v-deep .container .el-form-item{
  margin-bottom:0!important;
}

</style>